module.exports = __webpack_public_path__ + "static/media/fetal-pillow.f01771c7.png";